import { useDispatch } from 'react-redux';
import requests from '../../../../redux/reducer/requests';
import content from '../../../../redux/reducer/content';

export default function useGuessPriceCallbacks() {
  const dispatch = useDispatch();

  return {
    getGuessPriceTodayList: () => dispatch(requests.thunks.getGuessPriceTodayList()),
    setGuessPriceActiveIndex: (newActiveIndex) => dispatch(content.actions.setGuessPriceActiveIndex(newActiveIndex)),
    setGuessPriceThumbProgress: (thumbProgress) => dispatch(content.actions.setGuessPriceThumbProgress(thumbProgress)),
    checkGuessPrice: (data) => dispatch(requests.thunks.checkGuessPrice(data)),
    guessPriceToNext: () => dispatch(content.actions.guessPriceToNext()),
    updateGuessPriceResizeCount: () => dispatch(content.actions.updateGuessPriceResizeCount()),
  };
}
